module.exports = __webpack_public_path__ + "assets/img/feature_03.90fc9871.png";